import { useState, useEffect } from "react"
import styled from "styled-components"
import Card from "../ui/Card"

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const CoinGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`

const CoinCard = styled(Card)`
  padding: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  border-color: ${(props) => (props.isSelected ? props.theme.primary : props.theme.border)};
  
  &:hover {
    border-color: ${(props) => (props.isSelected ? props.theme.primary : props.theme.muted)};
  }
`

const CoinInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const CoinIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.accent};
`

const CoinDetails = styled.div``

const CoinSymbol = styled.div`
  font-size: 12px;
  font-weight: 500;
`

const CoinChange = styled.div`
  font-size: 10px;
  color: ${(props) => (props.positive ? props.theme.success : props.theme.error)};
`

const PremiumCard = styled(Card)`
  padding: 8px;
`

const PremiumLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
`

const PremiumValue = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.positive ? props.theme.success : props.theme.error)};
`

function ExchangeRateWidget() {
  const [rates, setRates] = useState({
    btc: { usd: 43256.78, krw: 43256.78 * 1350, change: 2.34 },
    eth: { usd: 2345.92, krw: 2345.92 * 1350, change: 1.21 },
    xrp: { usd: 0.5678, krw: 0.5678 * 1350, change: -0.45 },
    eos: { usd: 0.9876, krw: 0.9876 * 1350, change: 0.67 },
  })

  const [selectedCoin, setSelectedCoin] = useState("btc")
  const [kimpPremium, setKimpPremium] = useState(0)

  // Simulate fetching exchange rates
  useEffect(() => {
    // Calculate Kimchi premium (difference between Korean and global prices)
    const premium = ((rates[selectedCoin].krw / 1350 - rates[selectedCoin].usd) / rates[selectedCoin].usd) * 100

    setKimpPremium(premium)
  }, [selectedCoin, rates])

  return (
    <Container>
      <CoinGrid>
        {Object.keys(rates).map((coin) => (
          <CoinCard key={coin} isSelected={selectedCoin === coin} onClick={() => setSelectedCoin(coin)}>
            <CoinInfo>
              <CoinIcon />
              <CoinDetails>
                <CoinSymbol>{coin.toUpperCase()}</CoinSymbol>
                <CoinChange positive={rates[coin].change > 0}>
                  {rates[coin].change > 0 ? "+" : ""}
                  {rates[coin].change.toFixed(2)}%
                </CoinChange>
              </CoinDetails>
            </CoinInfo>
          </CoinCard>
        ))}
      </CoinGrid>

      <PremiumCard>
        <PremiumLabel>Kimchi Premium</PremiumLabel>
        <PremiumValue positive={kimpPremium > 0}>{kimpPremium.toFixed(2)}%</PremiumValue>
      </PremiumCard>
    </Container>
  )
}

export default ExchangeRateWidget
